import api from '@app/services/api';
import type { ApiError, ClientViewParams, ClientViewResponse } from '@app/services/api.types';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<ClientViewResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchClient = async ({ id }: ClientViewParams): Promise<ClientViewResponse> => {
    const url = apiEndpoints.users.getSingle(id);
    const response = await api.get(url);
    return response?.data?.data;
};

const useClient = (params: ClientViewParams, options?: QueryOptions) => {
    return useQuery<ClientViewResponse, ApiError>({
        queryKey: ['user', 'single', params],
        queryFn: () => fetchClient(params),
        ...options,
        enabled: Boolean(params.id),
    });
};

export default useClient;
